import React, { Suspense } from "react";
import { Box, Typography, Link, Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

const InstagramIcon = React.lazy(() => import("@mui/icons-material/Instagram"));
const FacebookIcon = React.lazy(() => import("@mui/icons-material/Facebook"));
const XIcon = React.lazy(() => import("@mui/icons-material/X"));

const CategoryLink = styled(Link)({
  color: "#1d1d1f",
  textDecoration: "none",
  fontSize: "11px",
  fontWeight: 600,
  textTransform: "uppercase",
  letterSpacing: "0.2em",
  opacity: 0.7,
  transition: "all 0.3s ease",
  display: "block",
  "&:hover": { opacity: 1 },
});

const ColumnTitle = styled(Typography)({
  color: "#1d1d1f",
  fontWeight: 800,
  fontSize: "14px",
  marginBottom: "20px",
  letterSpacing: "-0.01em",
});

const Footer = ({ isSmall, showOwnership = false }) => {
  return (
    <Box
      component="footer"
      sx={{
        width: "100%",
        px: isSmall ? 3 : 6,
        pt: 8,
        pb: "calc(2rem + env(safe-area-inset-bottom, 0px))",
        bgcolor: "#f5f5f7",
        borderTop: isSmall ? "none" : "1px solid rgba(0,0,0,0.08)",
        zIndex: 10,
      }}
    >
      <Grid
        container
        spacing={isSmall ? 4 : 2}
        sx={{
          mb: 8,
          textAlign: { xs: "left", md: "center" }, // Left aligned on mobile, center on desktop
        }}
      >
        {/* Safety & Legal */}
        <Grid item xs={6} sm={6} md={3}>
          <ColumnTitle>Safety & Legal</ColumnTitle>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
            <CategoryLink href="/community-guidelines">
              Community Guidelines
            </CategoryLink>
            <CategoryLink href="/privacy-policy">Privacy Policy</CategoryLink>
            <CategoryLink href="/terms-of-service">
              Terms of Service
            </CategoryLink>
            {/* <CategoryLink href="/data-deletion">
              Data Deletion & Permissions
            </CategoryLink> */}
            <CategoryLink href="/cookie-use">Cookie Policy</CategoryLink>
          </Box>
        </Grid>

        {/* Company */}
        <Grid item xs={6} sm={6} md={3}>
          <ColumnTitle>Company</ColumnTitle>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
            <CategoryLink href="/about">About Us</CategoryLink>
            <CategoryLink href="/how-it-works">How It Works</CategoryLink>
            {/* <CategoryLink href="/news">News</CategoryLink> */}
            {/* <CategoryLink href="/careers">Careers</CategoryLink> */}
            <CategoryLink href="/contact">Contact</CategoryLink>
          </Box>
        </Grid>

        {/* Development */}
        {/* <Grid item xs={6} sm={6} md={3}>
          <ColumnTitle>Development</ColumnTitle>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
            <CategoryLink href="/developer-support">
              Developer Support
            </CategoryLink>
            <CategoryLink href="/api-docs">API Documentation</CategoryLink>
            <CategoryLink href="/open-source">Open Source</CategoryLink>
          </Box>
        </Grid> */}

        {/* Support & Follow Us */}
        <Grid item xs={6} sm={6} md={3}>
          {/* <ColumnTitle>Support</ColumnTitle>
          <Box
            sx={{ display: "flex", flexDirection: "column", gap: 1.5, mb: 4 }}
          >
            <CategoryLink
              href="/report-incident"
              sx={{ color: "#d32f2f", opacity: 0.9 }}
            >
              Report an Incident
            </CategoryLink>
            <CategoryLink href="/help-center">Help Center</CategoryLink>
          </Box> */}

          {/* Follow Us Section */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: { xs: "flex-start", md: "center" }, // Align items left on mobile
            }}
          >
            <Typography
              sx={{
                color: "#1d1d1f",
                fontWeight: 800,
                fontSize: "14px",
                mb: 2,
              }}
            >
              Follow Us
            </Typography>
            <Box
              sx={{
                display: "flex",
                gap: 2.5,
                alignItems: "center",
                justifyContent: { xs: "flex-start", md: "center" }, // Align icons left on mobile
                ml: { xs: -0.5, md: 0 }, // Optical adjustment for icons
              }}
            >
              <Link
                href="https://www.instagram.com/thelinkup.ca/"
                target="_blank"
                color="inherit"
              >
                <Suspense fallback={null}>
                  <InstagramIcon
                    sx={{
                      fontSize: 22,
                      opacity: 0.8,
                      "&:hover": { opacity: 1 },
                    }}
                  />
                </Suspense>
              </Link>
              <Link
                href="https://twitter.com/TheLinkupInc/"
                target="_blank"
                color="inherit"
              >
                <Suspense fallback={null}>
                  <XIcon
                    sx={{
                      fontSize: 18,
                      opacity: 0.8,
                      "&:hover": { opacity: 1 },
                    }}
                  />
                </Suspense>
              </Link>
              <Link
                href="https://www.facebook.com/people/The-Linkup/61565677733492/"
                target="_blank"
                color="inherit"
              >
                <Suspense fallback={null}>
                  <FacebookIcon
                    sx={{
                      fontSize: 22,
                      opacity: 0.8,
                      "&:hover": { opacity: 1 },
                    }}
                  />
                </Suspense>
              </Link>
            </Box>
          </Box>
        </Grid>
      </Grid>

      {/* Final Copyright */}
      <Box
        sx={{
          borderTop: "1px solid rgba(0,0,0,0.08)",
          pt: 4,
          textAlign: "center",
        }}
      >
        <Typography
          sx={{
            fontSize: "11px",
            color: "rgba(0,0,0,0.5)",
            letterSpacing: "0.1em",
            textTransform: "uppercase",
            fontWeight: 600,
          }}
        >
          © 2026 THE LINKUP. ALL RIGHTS RESERVED.
        </Typography>
        {showOwnership && (
          <Typography
            display="block"
            sx={{ color: "rgba(0,0,0,0.4)", fontSize: "10px", mt: 1 }}
          >
            Owned and operated by Jenise Kwame Amoah.
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default Footer;
